import { type SupporterTabValue } from '../components/SupporterTabs'

export function supporterProfileUrl(groupId: string, supporterId: string, tab?: SupporterTabValue) {
  const base = `/groups/${groupId}/supporters/${supporterId}`
  if (tab) {
    return `${base}?tab=${tab}`
  }
  return base
}

export function callingSessionSupporterUrl(callingSessionId: string, supporterId: string) {
  return `/calling_sessions/${callingSessionId}/supporters/${supporterId}`
}

export function addSupporterUrl(groupId: string) {
  return `/groups/${groupId}/supporters/new`
}

export function viewAllSupportersUrl(callingSessionId: string) {
  return `/calling_sessions/${callingSessionId}/supporters`
}
